// locale for bounce
import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('bounce_locale');
module.exports = locale;
